export default function Unauthorized() {
  return (
    <div className="container">
      <div className="max-w-screen-lg mx-auto text-center">
        <h1>Unauthorized</h1>
        <p className="my-3">Are you where you're supposed to be?</p>
      </div>
    </div>
  );
}
